import { UPDATE_PLANS } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    plans: null,
};

const updatePlans = (state, action) => {
    return updateState(state, {
        plans: action.plans,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PLANS:
            return updatePlans(state, action);
        default:
            return state;
    }
};

export default reducer;
